import script from "./AppDatatable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDatatable.vue?vue&type=script&setup=true&lang=ts"

import "./AppDatatable.vue?vue&type=style&index=0&id=51f81f6b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f81f6b"]])

export default __exports__